<div class="animated fadeIn">
  <div class="catalog-list-body ui-g">
    <div class="catalog-list-content ui-g-12 prime-ng-15-table">
      <p-table class="catalog-list" #dt [columns]="columns" [value]="records" [lazy]="true" [scrollable]="true"
        [customSort]="true" [sortField]="'title'" [sortOrder]="1">
        <ng-template pTemplate="header" let-columns>
          <tr class="catalog-grid-row-header">
            <th class="catalog-checkbox">
              <!-- [disabled]="pricingMatrix?.updateSyncItems"
              [pTooltip]="pricingMatrix?.updateSyncItems ? 'Updated pricing matric has already been applied to this item':null"
               -->
              <app-checkbox [isChecked]="selectAllItems" [greenCheckbox]="true" (click)="handleSelectAllItems()"
                [checkState]="tableCheckState"> </app-checkbox>
            </th>
            <th *ngFor="let col of columns" [ngClass]="col.className">
              {{col.header}}
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex" let-columns="columns">
          <tr class="catalog-grid-row" *ngIf="records.length > 0">
            <td class="catalog-checkbox">
              <div>
                <!-- [disabled]="rowData?.isSelected" -->
                <app-checkbox [greenCheckbox]="true" [disabled]="rowData?.isSelected"
                  [isChecked]="getValueFromSelectedItemList(rowData?._id) || rowData?.isSelected"
                  [pTooltip]="rowData?.isSelected ? 'Updated pricing matric has already been applied to this item':null"
                  tooltipPosition="top" [checkState]="tableCheckState" (click)="pushToList(rowData, $event)">
                </app-checkbox>
              </div>
            </td>
            <td *ngFor="let col of columns" [ngClass]="col.className">

              <span *ngIf="col.field !== 'cost' &&
              col.field !== 'price' &&
              col.field !== 'flatRate' &&
              col.field !== 'totalAmount' &&
              col.field !== 'itemName' &&
              col.field !== 'categoryName' &&
              col.field !== 'updatedPrice'" class="capitalize">
                {{ rowData[col.field] }}
              </span>

              <span [pTooltip]="rowData[col.field]" tooltipPosition="top" *ngIf="col.field === 'itemName' ||
              col.field === 'categoryName'" class="capitalize">
                {{ rowData[col.field] }}
              </span>

              <span *ngIf="col.field === 'cost' ||
              col.field === 'price' ||
              col.field === 'flatRate' ||
              col.field === 'totalAmount' ||
              col.field === 'updatedPrice'" [ngClass]="changeRedColor(col.field, rowData)">
                {{ rowData[col.field] || 0 | currency: usd }}
              </span>
            </td>
          </tr>
        </ng-template>
      </p-table>

      <div class="ui-g-12 text-center not-found" *ngIf="loading && !records.length">
        Loading...
      </div>

      <div *ngIf="!loading && !records.length" class="ui-g-12 text-center not-found">
        <span class="font-gray-35 font-12 mt-2">There are no items in list</span>
      </div>

      <p-paginator class="ui-g-12 p-0" [hidden]="records.length == 0 || totalRecords < 10" #pp [rows]="10" [totalRecords]="totalRecords"
        (onPageChange)="paginate($event)"> </p-paginator>
    </div>

  </div>
</div>
